import React, { useContext } from 'react'
import { View } from 'oio-react'
import ContentView from 'src/components/Content/View'
import Footer from 'src/components/Footer'
import { useOrganization } from 'src/graphql/hooks'
import PageUIContext from 'src/libraries/contexts/PageUI'
import ThemeContext from 'src/libraries/contexts/Theme'
import PageActions from '~/Page/components/Actions'
import PageStatusBar from '~/Page/components/StatusBar'
import PageContext from '~/Page/libraries/context'

const PageView = () => {
   const theme = useContext(ThemeContext)
   const page = useContext(PageContext)
   const { organization } = useOrganization()
   const { currentUserCanEdit } = organization

   // This margin is temporary - it is there to add
   // a certain amount of whitespace above the page content
   let tmpPageVerticalMargin = '30px[a-b] 60px[c-f]'

   // TODO: Hack - Temporary until we have proper theme props
   // See PR: #309
   // See #341
   const tmpCustomPageContextProps = {}
   const tmpCustomFooterProps = {}
   if (organization.slug === 'fuse' || organization.slug === 'gns3') {
      tmpPageVerticalMargin = '0px'
      tmpCustomPageContextProps.contentMaxWidth = '100%'
      tmpCustomPageContextProps.contentPaddingLeft = '0px'
      tmpCustomPageContextProps.contentPaddingRight = '0px'
      tmpCustomPageContextProps.contentPaddingVertical = '0px'

      tmpCustomFooterProps.backgroundColor = '#000'
      tmpCustomFooterProps.textColor = '#777'
   }

   return (
      <>
         <View
            display="flex"
            justifyContent="center"
            width="100%"
            paddingTop={theme.viewportMarginTop}
            paddingLeft={theme.viewportMarginLeft}
            paddingRight={theme.viewportMarginRight}>
            <View width="100%">
               <PageStatusBar page={page} />
               <View
                  float="left"
                  width="100%"
                  minHeight="85vh"
                  paddingVertical={tmpPageVerticalMargin}>
                  <PageUIContext.Provider
                     value={{
                        contentMaxWidth: '1000px[a-e] 1200px[f]',
                        contentPaddingLeft: theme.viewportPaddingLeft,
                        contentPaddingRight: theme.viewportPaddingLeft,
                        contentPaddingVertical: '12px',
                        ...tmpCustomPageContextProps
                     }}>
                     <ContentView elements={page.body.elements} />
                  </PageUIContext.Provider>
               </View>
               <Footer {...tmpCustomFooterProps} />
            </View>
         </View>
         {currentUserCanEdit && <PageActions />}
      </>
   )
}

export default PageView
